module.exports = __webpack_public_path__ + "static/media/el-naranjal-360-preview.5f04a79c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/360photos/el-naranjal-360-preview.jpg
// module id = 1151
// module chunks = 0